import { useLocation } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import type { DomainGetAppVersionResponse } from '@/Swagger';
import axiosInstance from '@/axios/axios';

import { queryKeys } from './queryKeys';

/**
 * 강제 업데이트 버전을 조회
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Business/get_shops__shopID__business
 */
export default function useGetUpdateVersion() {
  const location = useLocation();

  return useQuery({
    queryKey: [...queryKeys.version, location.pathname] as const,
    queryFn: async () => {
      return axiosInstance.get<DomainGetAppVersionResponse>('/shops/app-version').then(v => v.data);
    },
    gcTime: 0,
  });
}
